import { createStyles } from '@mantine/core';

export default createStyles(() => ({
  button: {
    marginLeft: 7,
  },
}));
